import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { UserDataService } from 'src/app/core/services/user-data.service';

@Injectable({
  providedIn: 'root',
})
export class ForbiddenGuard {
  constructor(
    private userDataService: UserDataService,
    private permissionsService: PermissionsService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (route.queryParams['submodule']) {
      return true;
    }

    if (this.permissionsService.hasAddonAccess(route.params['addon'])) {
      this.router.navigateByUrl('/secured/home');
      return false;
    }

    return true;
  }
}
